import styled from 'styled-components'

export const IconButton = styled.div`
    position: relative;
    cursor: pointer;

    .hidden {
        display: none;
    }

    span {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -7px;
        left: 12px;
        color: #fff;
        background: #3fd97f;
        border-radius: 20px;
        font-family: 'Roboto';
        font-weight: 500;
        font-size: 12px;

        /* padding: 3px; */
        width: 20px;
        height: 20px;
    }
`

export const Container = styled.div`
    /* &::before {
        content: '';
        background: rgba(0, 0, 0, 0.24);
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: -10;
        top: 0;
        right: 0;
    } */
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 6px 0px 0px 6px;
    overflow: auto;
    position: fixed;
    z-index: 9;
    top: 0;
    right: 0;
    /* min-width: 300px; */
    /* max-width: 350px; */
    width: 300px;

    @media (min-width: 678px) {
        /* right: 100px; */
        min-width: 500px;
        height: 100%;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .details {
        border-top: 1px solid #d3d3d3;
        /* border-bottom: 1px solid #D3D3D3; */
        padding: 14px 10px;

        p + p {
            margin-top: 6px;
        }

        p {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-family: 'Roboto';
            font-size: 17px;
            color: #333;
        }

        span {
            font-weight: 500;
        }
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
        padding: 10px;
        border-top: 1px solid #d3d3d3;
        span {
            display: flex;
            align-items: center;
            gap: 4px;
            color: red;

            font-size: 13px;
            font-family: 'Roboto';
            cursor: pointer;
            transition: color 0.2s;
            &:hover {
                color: #566583;
            }
        }
        .button {
            padding: 8px 10px;
            border-radius: 6px;
            font-family: 'Inter';
            background: #1976d2;
            color: #fff;
            font-size: 15px;
        }
    }

    .click {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        width: 100%;

        font-family: 'Inter';
        font-size: 12px;
        font-weight: 500;
        color: #333;
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
            background: rgba(0, 0, 0, 0.05);
            background: rgba(0, 157, 221, 0.1);
            /* border-radius: 8px; */
        }
    }
`

export const Title = styled.div`
    height: 47px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #d3d3d3;
    > div {
        display: flex;
        align-items: center;
        gap: 4px;
        p {
            font-family: 'Inter', sans-serif;
            font-weight: 500;
            font-size: 20px;
        }
        span {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #3fd97f;
            background: rgba(90, 219, 148, 0.3);
            border-radius: 6px;
            font-family: 'Roboto';
            font-weight: 500;
            font-size: 12px;

            width: 20px;
            height: 20px;
        }
    }
`

export const ListContainer = styled.div`
    overflow: auto;
    /* max-height: max-content; */
    flex-grow: 1;
    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }
`

export const List = styled.ul`
    max-height: 300px;
    /* overflow: auto; */

    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }

    .item {
        border-bottom: 1px solid #d3d3d3;
    }
    .item {
        cursor: pointer;
        padding: 8px;

        .data {
            display: flex;
            flex-direction: column;
            gap: 4px;

            p {
                font-family: 'Inter', sans-serif;
                font-size: 15px;
                color: #333;
            }

            span {
                font-weight: 500;
            }
        }
        .total {
            margin-top: 4px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            font-family: 'Inter', sans-serif;

            span {
                font-size: initial;
                color: #333;
                font-weight: 500;
            }
        }
        &:hover {
            background: rgba(0, 157, 221, 0.1);
        }
    }
    .message {
        padding: 14px 10px;
        font-family: 'Roboto';
        font-size: 18px;
    }

    @media (min-width: 1440px) {
        max-height: 600px;
    }
`

export const OneCLick = styled.div`
    padding: 10px;

    form {
        .input-wrapper {
            margin-bottom: 8px;

            input {
                height: 10px;
            }
            .hook-error {
                color: #f7345b;
                font-family: 'Inter';
                font-size: 14px;
            }
        }
    }

    .help {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        margin-bottom: 8px;
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 500;
        color: #566583;
    }

    .cadastrar {
        font-family: 'Inter';
        font-size: 14px;
        font-weight: 500;
        color: #333;

        a {
            color: #4c83ee;

            &:hover {
                color: #566583;
            }
        }
    }
`
